module.exports = __webpack_public_path__ + "img/cup.ee7003a0.svg";